module.exports = __webpack_public_path__ + "media/bootstrap-icons/dash-circle-dotted-4f9480e9.svg";